module.exports = __webpack_public_path__ + "assets/img/0.e12fb0a6.png";